import { createContext, useCallback, useMemo, useState } from 'react'

import { Outlet } from 'react-router'

export interface CourseContext {
  currentVideoId: string | null
  setCurrentVideo: (id: string) => void
}

export const CourseStateContext = createContext<CourseContext | undefined>(
  undefined,
)

export const CourseProvider = () => {
  const [currentVideoId, setCurrentVideoId] = useState<string | null>(null)

  const setCurrentVideo = useCallback(
    (id: string) => {
      setCurrentVideoId(id)
    },
    [setCurrentVideoId],
  )

  const values = useMemo<CourseContext>(
    () => ({
      currentVideoId,
      setCurrentVideo,
    }),
    [currentVideoId, setCurrentVideo],
  )

  return (
    <CourseStateContext.Provider value={values}>
      <Outlet />
    </CourseStateContext.Provider>
  )
}
